<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';


export default {
    data: function() {
        return {
            tour: '',
            video: ''
        };
    },
    props: [
        "interactiveTour",
        "videoTour",
        "dataUrl",
        "modalOpen",
        "modalClose"
    ],
    computed: {
       ...mapGetters({getData: 'floorplanImageGallery/getData'}),
       galleryData() {
           return this.getData.galleryData;
       },

       videoId() {
            const originalUrl = this.videoTour;

            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            const match = originalUrl.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
         }
   },
    methods: {
        ...mapActions({
            put: 'floorplanImageGallery/put'
        }),

        openModal(modal) {
            this.$eventsBus.$emit('open-modal', [modal]);
        },

        imageGalleryModal: function() {
            this.openModal('modal-floorplan-gallery');
       },
       videoModal: function() {
        this.openModal('modal-floorplan-video');
       },
       openInteractiveTourModal: function(id, event) {
          const mobile = window.matchMedia( "(max-width: 767px)" );
          const targetLink = this.interactiveTour;
          if(mobile.matches) {
            window.open(targetLink, '_blank');

          } else {
            this.$eventsBus.$emit('open-modal', ['modal-interactive-floorplan', { tour:this.interactiveTour }]);
          }
       },
       openVideoModal: function(id) {
          var video = 'https://www.youtube.com/embed/' + this.videoId;
          this.$eventsBus.$emit('open-modal', ['modal-video-floorplan', { video:video }]);
       }
    },

};
</script>



// WEBPACK FOOTER //
// resources/components/apps/floorplan-image-gallery.vue